import React from 'react';
import Navbar from './NavBar';
import Contact from './Contact';
import desktopPic from '../assets/img/11.jpeg';
import mobilePic from '../assets/img/11_.jpeg';


// Import trustee and council images
import tonyOputa from '../assets/img/anthony.jpeg';
import paulObi from '../assets/img/paulobi.jpg';
import samObaze from '../assets/img/sam.jpeg';
import godwinOsuji from '../assets/img/godwin.jpeg';
import jessCastollote from '../assets/img/jess.jpeg';
import jideOgunyemi from '../assets/img/babajide.jpeg';
import francisOnwumere from '../assets/img/francis.jpeg';
import ikechukwuOnuoma from '../assets/img/ikechukwu.jpeg';

import victorBraimah from '../assets/img/victor.jpeg';
import tunjiMakun from '../assets/img/empty.jpg';
import peterBamkole from '../assets/img/peter.jpeg';
import kingsleyEkwem from '../assets/img/empty.jpg';
import ernestIkeh from '../assets/img/empty.jpg';
import chimezieAnyakora from '../assets/img/chimezie.jpeg';
import darlingtonAgholor from '../assets/img/darlington.jpeg';
import davidOkechukwu from '../assets/img/david.jpeg';
import norbertEdomah from '../assets/img/norbert.jpeg';

const trustees = [
  { name: 'MR. TONY OPUTA (Chairman)', img: tonyOputa },
  { name: 'COL. (Rtd.) PAUL OBI', img: paulObi },
  { name: 'MR. SAM OBAZE', img: samObaze },
  { name: 'MR. GODWIN OSUJI', img: godwinOsuji },
  { name: 'ARC. JESS CASTOLLOTE', img: jessCastollote },
  { name: 'MR. JIDE OGUNYEMI', img: jideOgunyemi },
  { name: 'MR. FRANCIS ONWUMERE', img: francisOnwumere },
  // { name: 'MR. IKECHUKWU ONUOMA (Esq) (Secretary)', img: ikechukwuOnuoma },
];

const councilMembers = [
  { name: 'MR. VICTOR BRAIMAH (Chairman)', img: victorBraimah },
  { name: 'SIR. TUNJI MAKUN', img: tunjiMakun },
  { name: 'MR. PETER BAMKOLE', img: peterBamkole },
  { name: 'MR. KINGSLEY EKWEM (Esq)', img: kingsleyEkwem },
  { name: 'MR. ERNEST IKEH', img: ernestIkeh },
  { name: 'DR. CHIMEZIE ANYAKORA', img: chimezieAnyakora },
  { name: 'DR. DARLINGTON AGHOLOR', img: darlingtonAgholor },
  { name: 'MR. DAVID OKECHUKWU', img: davidOkechukwu },
  { name: 'DR. NORBERT EDOMAH', img: norbertEdomah },
];

const History = () => {
  return (
    <>
     <Navbar />
      <div>
        {/* Mobile image: visible on small screens only */}
        <img
          src={mobilePic}
          alt="mobile"
          className="w-full h-[60vh] lg:hidden object-cover"
        />

        {/* Desktop image: visible on large screens and above */}
        {/* <img
          src={desktopPic}
          alt="desktop"
          className="w-full h-[540px] hidden lg:block object-cover"
        /> */}
      </div>
      <div name='history' className='w-full min-h-screen bg-white text-gray-700 pt-10 pb-10'>
      <div className='hidden lg:flex items-center justify-center bg-[white] h-[120px]'>
        {/* <h1 className='text-5xl font-bold text-[#15381b]'>About Us</h1> */}
      </div>
        <div className='container mx-auto lg:px-40 md:px-20 px-6'>
          <h1 className='text-4xl font-semibold text-center mb-8'>Who We Are</h1>

          {/* Our Mission Section */}
          <div className='mb-10'>
            <h2 className='text-3xl font-semibold text-gray-900 mb-4'>Our Mission</h2>
            <p className='text-lg mb-4'>
            ADF advances education, character development, and ethical leadership among African youth. Through scholarships, infrastructure, and vocational training, we equip individuals with the skills and values to uplift their communities and drive sustainable societal progress.
            </p>
            {/* <p className='text-lg'>
              We are committed to fostering character development and shaping a responsible society guided by ethical values and Christian principles.
            </p> */}
          </div>

          {/* Our Vision Section */}
          <div className='mb-10'>
            <h2 className='text-3xl font-semibold text-gray-900 mb-4'>Our Vision</h2>
            <p className='text-lg mb-4'>
            To ensure every young African has access to quality education and opportunities that foster leadership, innovation, and sustainable development.
            </p>
            {/* <p className='text-lg'>
              Through strategic investments in education, vocational training, and leadership development, we aim to build a society driven by innovation, ethics, and sustainable progress.
            </p> */}
          </div>

          {/* Brief History Section */}
          <div>
            <h2 className='text-3xl font-semibold text-gray-900 mb-4'>Brief History</h2>
            <p className='text-lg mb-4'>
            African Development Foundation (ADF) is a non-profit organization founded in 1994 with a mission to promote education and social welfare in Nigeria.
            </p>
            <p className='text-lg mb-4'>
            ADF's first projects included the Lagos Business School (LBS) and later the Pan African University (now Pan Atlantic University - PAU). LBS provided continued education for professionals in the corporate world, while PAU offered academic courses, starting with short courses and Masters programs in specific fields.
            </p>
            <p className='text-lg mb-4'>
            In 2000, ADF initiated the Institute for Industrial Technology (IIT) to provide vocational training for young Nigerians, aiming to lift them from economically challenged backgrounds out of poverty and equip them with technical skills needed in the manufacturing and allied industry.
            </p>
            <p className='text-lg mb-4'>
            ADF continues to support and promote IIT as a leading provider of Technical and Vocational Education and Training (TVET) in Nigeria, contributing to the development of skilled manpower in the industrial sector.
            </p>
            <p className='text-lg'>
            With the establishment of the Pan African University Foundation (now Pan Atlantic University Foundation - PAUF) in 2010, ADF refocused its efforts on promoting the development of PAU, while continuing to support IIT and other educational endeavors.
            </p>
          </div>

          <div className='mt-16'>
            <h1 className='text-4xl font-semibold  mb-8'>Governance</h1>

            <p className='text-lg mb-6'>
              The African Development Foundation is a non-profit organization committed to driving sustainable growth and development across Africa. The foundation operates with a clear governance structure to ensure transparency, accountability, and alignment with its core mission.
            </p>
            
            <h2 className='text-2xl font-semibold mt-8 mb-4'>Leadership and Governance</h2>
            <p className='text-lg mb-6'>
              The foundation's assets and operations are overseen by the Board of Trustees, who uphold the vision and ensure strategic direction. Their primary responsibilities include appointing leadership, approving policies, and maintaining the integrity of the foundation’s objectives.
            </p>
            
            <h3 className='text-xl font-semibold mt-6 mb-6'>Board of Trustees</h3>
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8'>
            {trustees.map((person, index) => (
              <div key={index} className='text-center'>
                <img src={person.img} alt={person.name} className='w-40 h-40 mx-auto rounded-full object-cover' />
                <p className='mt-3 font-semibold text-lg'>{person.name}</p>
              </div>
            ))}
          </div>
            
            <h2 className='text-2xl font-semibold mt-10 mb-4'>Governing Council</h2>
            <p className='mb-6 text-lg'>
              The Governing Council is responsible for strategic decision-making and policy implementation. This council ensures that the foundation’s initiatives align with its long-term vision and oversees key appointments, budgeting, and new project developments.
            </p>

            <h3 className='text-xl font-semibold mt-6 mb-6'>Members of the Governing Council</h3>
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8'>
            {councilMembers.map((person, index) => (
              <div key={index} className='text-center'>
                <img src={person.img} alt={person.name} className='w-40 h-40  mx-auto rounded-full object-cover' />
                <p className='mt-3 font-semibold text-lg'>{person.name}</p>
              </div>
            ))}
          </div>
          </div>
        </div>
      </div>
      <Contact />
    </>
  );
};

export default History;
